<div class="action-bar">
    <form (ngSubmit)="onSubmitAction($event)" autocomplete="off">
        <div class="row">
            <div class="col px-0">
                <div class="action-bar-content">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </form>
</div>
